import http from '../../utils/httpService';
import { PERMISSION_ROUTE } from './constants';

/**
 *
 * @returns {*}
 */
const requestPermissions = () => (
    http.request(PERMISSION_ROUTE, 'GET', null, false)
);

/**
 *
 * @param formData
 * @returns {*}
 */
const requestCreatePermission = (formData) => {
    const route = PERMISSION_ROUTE;
    return http.request(route, 'POST', formData);
};

/**
 *
 * @param formData
 * @returns {*}
 */
const requestUpdatePermission = (formData) => {
    const route = PERMISSION_ROUTE + `/${formData.id}`;
    return http.request(route, 'PUT', formData);
};

/**
 *
 * @param formData
 * @returns {*}
 */
const requestInvitePermission = (formData) => {
    const route = PERMISSION_ROUTE + '/invite';
    return http.request(route, 'POST', formData);
};

export {
    requestPermissions,
    requestCreatePermission,
    requestUpdatePermission,
    requestInvitePermission
};

